import script from "./FilesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesTable.vue?vue&type=script&setup=true&lang=ts"

import "./FilesTable.vue?vue&type=style&index=0&id=21d46b71&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d46b71"]])

export default __exports__